import { Platform } from 'shared/models';
import request from '../../features/regions/services/requester/region.request';

const platformService = {
  getPlatforms: () => request.get<Platform[]>('/platforms'),
};

export default platformService;
